import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SwipeableDrawer } from "@mui/material";
import React, { Dispatch, SetStateAction } from "react";
import { ActionType } from "../../modal/Modal";
import { BottomSheet } from "../BottomSheet";
import { Actions } from "./Actions";

export interface BottomDrawerProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  children: React.ReactChild;
  title?: string;
  subtitle?: string;
  showCloseButton?: boolean;
  drawerClassName?: string;
  useOldDrawer?: boolean;
  zIndex?: number;
  noPadding?: boolean;
  actions?: Array<ActionType>;
  floatingActions?: boolean;
  zMax?: boolean;
}

export const BottomDrawer = (props: BottomDrawerProps) => {
  const {
    open,
    setOpen,
    children,
    title,
    subtitle,
    showCloseButton = false,
    drawerClassName = "bg-background-primary",
    useOldDrawer = false,
    zIndex = 40,
    actions,
    noPadding,
    floatingActions = false,
    zMax,
  } = props;

  if (useOldDrawer)
    return (
      <BottomSheet
        open={open}
        setOpen={setOpen}
        onDismiss={() => setOpen(false)}
        showCloseButton
        dismissableHeader
      >
        {children}
      </BottomSheet>
    );

  const hasActions = actions?.length > 0;

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      onOpen={() => setOpen(true)}
      className="kanpla-bottom-drawer relative"
      style={{ zIndex: zMax ? "999" : zIndex }}
      PaperProps={{
        elevation: 0,
        style: {
          backgroundColor: "transparent",
          paddingTop: "10rem",
          zIndex: 9,
        },
      }}
    >
      <div
        className="bg-transparent w-full h-40 absolute inset-x-0 top-0"
        onClick={() => setOpen(false)}
      />
      <div
        className={`${drawerClassName} relative w-full pb-6`}
        style={{ borderRadius: "24px 24px 0 0" }}
      >
        {showCloseButton && (
          <CloseButton
            onClick={() => setOpen(false)}
            className="absolute top-4 right-4 z-50"
          />
        )}
        <header className="p-3 flex items-center justify-center relative z-50">
          <span className="block bg-background-secondary rounded-lg w-12 h-1"></span>
        </header>
        <main className="w-full flex flex-col justify-center mt-3 relative ">
          {title && (
            <h1 className="h700 text-text-primary text-center px-6 relative z-10">
              {title}
            </h1>
          )}
          {subtitle && (
            <h3 className="text-text-secondary text-center px-6">{subtitle}</h3>
          )}
          <div className={`${noPadding ? "p-0" : "pb-6 px-6 pt-6"}`}>
            {children}
          </div>
        </main>

        {hasActions && (
          <div
            className={`${
              floatingActions ? "sticky" : "relative"
            } bottom-0 w-full bg-gradient-to-b from-transparent to-background-primary`}
            style={{
              paddingBottom: `calc(var(--safe-inset-bottom) + 20px + 6rem)`,
            }}
          >
            <div className="flex flex-wrap justify-center whitespace-nowrap w-full p-2 overflow-hidden">
              <Actions actions={actions} />
            </div>
          </div>
        )}
      </div>
    </SwipeableDrawer>
  );
};

const CloseButton = ({ onClick, className = "" }) => {
  return (
    <div
      className={`rounded-full bg-background-secondary hover:opacity-60 transition-opacity ease-in-out text-text-primary flex justify-center items-center p-4 w-8 h-8 cursor-pointer ${className}`}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faTimes} />
    </div>
  );
};
